module.exports = __webpack_public_path__ + "img/ideum-logo--gold.0c350a1e.svg";